export default {"src":"/_next/static/media/wordpress.1166f3c2.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};